/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

export const StyledTable = styled(Table)`
  ${({ theme }) => `
    text-align: left;
    font-size: 14px;
    background: #FFFFFF;
    border-radius: ${theme.shape.borderRadius}px;
    border: 1px solid ${theme.palette.text.disabled};
    border-collapse: collapse;

    @media screen and (max-width: 40em) {
      &.responsiveTable {
        background: none;
        border: 0;

        tbody {
          tr {
             border: 1px solid ${theme.palette.text.disabled};
             padding: .25em;
             margin-bottom: 16px;
             background: none;
          }
            
          td {
            &:nth-child(odd) {
              background: #fafafa;
            }
          }
        }
      }
    }
  `}
`;

export const StyledThead = styled(Thead)`
  ${({ theme }) => `
    tr {
      border-bottom: 1px solid ${theme.palette.text.disabled};
    }
  `}
`;

export const StyledTbody = styled(Tbody)`
  ${({ theme }) => `
    tr:nth-child(odd) {
      background: #fafafa;
    }
  `}
`;

export const StyledTr = styled(Tr)`
  ${({ theme }) => `
    line-height: 1.25rem;
    vertical-align: baseline;
  `}
`;

export const StyledTh = styled(Th)`
  ${({ theme }) => `
    font-weight: 700;
    padding: ${theme.spacing(1.5)}px ${theme.spacing(2)}px;
  `}
`;

export const StyledTd = styled(Td)`
  ${({ theme }) => `
    font-weight: 400;
    padding: ${theme.spacing(1.5)}px ${theme.spacing(2)}px;
  `}
`;
